import _ from 'lodash';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { cx, PropTypes } from '~/utils';

const propMap = {
  fw      : 'fixedWidth',
  li      : 'listItem',
};

// eslint-disable-next-line complexity
export function Icon( props ) {
  const {
    icon, name, mask, className, disabled, label,
    color, background, style={},
    ...opts
  } = props;
  _.each( propMap, ( tgt, src ) => {
    if ( ! opts[ src ] ) return;
    opts[ tgt ] = opts[ src ];
    delete opts[ src ];
  } );
  if ( ! ( icon || name || label ) ) return null;
  if ( label && ! ( icon || name ) ) return <span>{label}</span>;
  opts.icon = _.compact( ( icon || name || '' ).split( ':' ) );
  if ( opts.icon.length !== 2 ) {
    // eslint-disable-next-line no-console
    console.error( 'INVALID ICON', { icon, name } );
    return null;
  }
  opts.className = cx( 'icon', { disabled }, className );
  if ( mask ) {
    const m = opts.mask.split( ':' );
    if ( m.length === 2 ) {
      opts.mask = m;
    } else {
      // eslint-disable-next-line no-console
      console.error( 'INVALID ICON MASK', { mask } );
    }
  }

  if ( color ) style.color = color;
  if ( background ) style.background = background;

  if ( ! _.isEmpty( style ) ) opts.style = style;
  if ( label ) {
    return (
      <span className="labeled-icon">
        <FontAwesomeIcon {...opts} />
        <span>{label}</span>
      </span>
    );
  } else {
    return <FontAwesomeIcon {...opts} />;
  }
}
Icon.propTypes = {
  border      : PropTypes.bool,
  className   : PropTypes.className,
  mask        : PropTypes.string,
  fixedWidth  : PropTypes.bool,
  inverse     : PropTypes.bool,
  flip        : PropTypes.oneOf( [ 'horizontal', 'vertical', 'both' ] ),
  icon        : PropTypes.string,
  name        : PropTypes.string,
  listItem    : PropTypes.bool,
  pull        : PropTypes.oneOf( [ 'left', 'right' ] ),
  pulse       : PropTypes.bool,
  rotation    : PropTypes.oneOf( [ 90, 180, 270 ] ),
  size        : PropTypes.oneOf( [
    'xs', 'sm', 'lg', ..._.map( _.range( 1, 10 ), x => `${x}x` ),
  ] ),
  spin        : PropTypes.bool,
  symbol      : PropTypes.oneOfType( [ PropTypes.string, PropTypes.bool ] ),
  title       : PropTypes.string,
  transform   : PropTypes.oneOfType( [ PropTypes.string, PropTypes.object ] ),
  prefix      : PropTypes.string,
  disabled    : PropTypes.bool,
  label       : PropTypes.string,
  href        : PropTypes.string,
  color       : PropTypes.string,
  background  : PropTypes.string,
  style       : PropTypes.object,
};
Icon.defaultProps = {
  disabled    : false,
  border      : false,
  className   : '',
  mask        : null,
  fixedWidth  : false,
  inverse     : false,
  flip        : null,
  icon        : null,
  listItem    : false,
  pull        : null,
  pulse       : false,
  rotation    : null,
  size        : null,
  spin        : false,
  symbol      : false,
  title       : '',
  transform   : null,
};
